import { useState, type FormEvent } from 'react';
import { credentialsSchema } from '@yucanvas/shared';
import { useAuth } from '../auth/AuthProvider';
import { InstallBanner } from '../components/InstallBanner';

export function LoginScreen() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);

    const parsed = credentialsSchema.safeParse({ email, password });
    if (!parsed.success) {
      setError(parsed.error.issues[0]?.message ?? 'Check your details.');
      return;
    }

    setBusy(true);
    try {
      await signIn(parsed.data.email, parsed.data.password);
    } catch (cause) {
      setError(
        cause instanceof Error ? cause.message : 'Could not sign in. Try again.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <h1 className="login__title">YuCanvas</h1>
      <p className="login__sub">Yucaipa door knocking</p>

      <form className="login__form" onSubmit={submit}>
        <label className="field">
          <span>Email</span>
          <input
            type="email"
            inputMode="email"
            autoComplete="username"
            autoCapitalize="none"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <label className="field">
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>

        {error ? <p className="banner banner--error">{error}</p> : null}

        <button className="btn btn--primary btn--huge" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>

      <p className="login__note">
        Accounts are created by an organizer, who gives you your first
        password. Stay signed in — the app keeps your session so you never hit
        a login screen at a door.
      </p>

      <p className="login__note">
        Forgotten your password? Ask your organizer to reset it.
      </p>

      <InstallBanner />
    </main>
  );
}
